import { Text, Title, DetailText } from "../../components/units/Text"
import { CommisionProps } from "../../components/Rest/Commission"
import { useSignedInContext } from "../../context/AuthContextProvider";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { BoxWrapper } from "../../components/Wrappers/Wrappers";
import { LgFormInput } from "../../components/Form/FormInput";
import { fetchCommissionData } from "../../components/Rest/Commission";
import { RestApiState } from "../../components/Rest/Organization";
import { CommisionCommentProps, updateCommissionComment } from "../../components/Rest/Commission";



interface UpdateCommissionProps {
    commission: {
        data: CommisionCommentProps | null;
        changes: Set<keyof CommisionProps>;
        requestState: RestApiState;
        timeOutId: NodeJS.Timeout | null;
        documentation?: any;
    }
}


const defaultUpdateCommissionState = { commission:{
    data: null,
    changes: new Set<keyof CommisionProps>(),
    requestState: RestApiState.Idle,
    timeOutId: null

}}


interface UpdateValueInterface {
    key: keyof CommisionProps;
    value: any;
}

function submitClassHandler(status: RestApiState): string {
    // Defines css class based on status
    if (status === RestApiState.Success) {
        return "submit-btn-success"
    }

    if (status !== RestApiState.Idle)  {
        return 'submit-btn disabled'
    }

    return "bg-secondary text-light"
}


export const UpdateCommissionComment = () => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()
    
    const [commissionProps, setProps] = useState<UpdateCommissionProps>(defaultUpdateCommissionState)

    if (serial_number === undefined) {
        throw new Error("Serial number must be provided as parameter")
    }

    useEffect(() => {
        async function myFunction() {
            if (commissionProps.commission.requestState !== RestApiState.Idle) {
                updateRestApiStatus(RestApiState.Idle);
            }
        }

        if (commissionProps.commission.timeOutId !== null) {
            clearTimeout(commissionProps.commission.timeOutId)
        }

        if (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) {
            let timeOut = setTimeout(myFunction, 1500);
            setProps((prev) => ({
                ...prev,
                commission: {
                    ...prev.commission,
                    timeOutId: timeOut, // Update the requestState field
                },
            }));
        }

    }, [commissionProps.commission.requestState])

    const statusText = ():string => {
        let text = ''
        switch(commissionProps.commission.requestState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Обновлено"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            default: text = "..."; break;
        }
        return text
    }

    const setCommissionData = (newData: typeof commissionProps.commission.data): void => {
        setProps(prev => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: newData,
            },
        }));
    }


    const updateDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        const key = name as keyof CommisionProps;
        
        setProps((prev) => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: prev.commission.data
                ? { ...prev.commission.data, [key]: value }
                : null,
            },
        }));
        
        setProps((prevState) => {
            const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
            updatedChanges.add(key); // Add the new key
            return {
                ...prevState,
                commission: {
                    ...prevState.commission,
                    changes: updatedChanges, // Update changes with the new Set
              },
            };
        });
    };

    const updateRestApiStatus = (status: RestApiState) => {
        setProps((prev) => ({
            ...prev,
            commission: {
                ...prev.commission,
                requestState: status, // Update the requestState field
            },
        }));
    }

    useEffect(() => {
        const fetchSectionData = async () => {
            fetchCommissionData(serial_number, user.role_slug, setCommissionData)
        }
        fetchSectionData()
    }, [])

    const handelSubmit = (e: any) => {
        e.preventDefault();
        updateCommissionComment(serial_number, user.role_slug, commissionProps.commission.data , updateRestApiStatus)
    }
    
    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <DetailText href={`/react/acb/detail/${serial_number}`}>
                    Назад
            </DetailText>
            <br />
            <br />
            <Title className="dispaly-block">{serial_number}</Title>
            <br />
            <BoxWrapper bg="bg-primary" p="p3" r="r15">
                <Text size="lg" className="bold dispaly-block">Форма ввода в эскплуатацию</Text>
                <br />
                {commissionProps.commission.data ? (
                    <form onSubmit={handelSubmit} className="organization-form">
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Администрация</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.comment} 
                                label='Комментарий' 
                                name='comment' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <button 
                                type="submit"
                                disabled={ commissionProps.commission.requestState !== RestApiState.Idle }
                                className={`${submitClassHandler(commissionProps.commission.requestState)} p2 bold` }
                                style={{position:'relative', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                                >
                                { commissionProps.commission.requestState === RestApiState.Idle && <Text  className="slide-bottom-to-top">Сохранить</Text>  }
                                { commissionProps.commission.requestState === RestApiState.Pending && <Text className="slide-bottom-to-top">{ <div className="btnloader"></div> }</Text>}
                                { (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>} 
                            </button>
                        </div>
                        
                    </form>
                ) : (
                    <h1>Loading...</h1>
                )}
            </BoxWrapper>

        </div>
    )
}